/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DonationAnswersDto } from './DonationAnswersDto';
import {
    DonationAnswersDtoFromJSON,
    DonationAnswersDtoFromJSONTyped,
    DonationAnswersDtoToJSON,
    DonationAnswersDtoToJSONTyped,
} from './DonationAnswersDto';

/**
 * 
 * @export
 * @interface DonationsTabResponse
 */
export interface DonationsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof DonationsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {DonationAnswersDto}
     * @memberof DonationsTabResponse
     */
    answers: DonationAnswersDto;
}

/**
 * Check if a given object implements the DonationsTabResponse interface.
 */
export function instanceOfDonationsTabResponse(value: object): value is DonationsTabResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('answers' in value) || value['answers'] === undefined) return false;
    return true;
}

export function DonationsTabResponseFromJSON(json: any): DonationsTabResponse {
    return DonationsTabResponseFromJSONTyped(json, false);
}

export function DonationsTabResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DonationsTabResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'answers': DonationAnswersDtoFromJSON(json['answers']),
    };
}

export function DonationsTabResponseToJSON(json: any): DonationsTabResponse {
    return DonationsTabResponseToJSONTyped(json, false);
}

export function DonationsTabResponseToJSONTyped(value?: DonationsTabResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'answers': DonationAnswersDtoToJSON(value['answers']),
    };
}

